import Rails from '@rails/ujs';

window.addEventListener('load', function(){
  var institution_input = document.getElementById('institutions-search');
  if(institution_input != undefined) {
    institution_input.addEventListener('keyup', function(event){
      event.preventDefault();
      var input_value = event.target.value;
      var ul_element = document.getElementById('institutions-list');
      if (input_value.length >= 3) {
        Rails.ajax({
          type: "GET",
          url: "/institutions/fetch_by_name",
          data: "name="+input_value,
          contentType: "json",
          success: function(response) {
            ul_element.innerHTML = "";
            if(response.length > 0) {
              for(var i = 0; i < response.length; i++){
                var li = document.createElement("li");
                var a = document.createElement("a");
                var linkText = document.createTextNode(response[i]["name"]);
                a.appendChild(linkText);
                a.href = institution_url(response[i]["id"]);
                li.appendChild(a);
                ul_element.appendChild(li);
              }
            }
          }
        });
      } else {
        ul_element.innerHTML = "";
      }
    });
  }

  function institution_url(response_id) {
    var url_prefix_el = document.getElementsByName('url_prefix')

    var url_prefix = ""
    if (url_prefix != undefined) {
      url_prefix = url_prefix_el[0].value;
    }

    return url_prefix+"/institutions/"+response_id+"/edit"+typeform_params();

  }

  function typeform_params() {
    var typeform_id = document.getElementsByName('typeform_id')
    var typeform_email = document.getElementsByName('typeform_email')

    var email = "";
    var id = "";

    if (typeform_email != undefined) {
      email = typeform_email[0].value;
    }

    if (typeform_id != undefined) {
      id = typeform_id[0].value;
    }

    var string_params = ""
    if(email.length > 0) {
      string_params = string_params+"&typeform_email="+email;
    }
    if(id.length > 0) {
      string_params = string_params+"&typeform_id="+id;
    }

    if(string_params.length > 0) {
      string_params = "?"+string_params;
    }
    return string_params;
  }
});
